import React from 'react';
import useLongPress from './longPress';
import cn from 'classnames';

const Button = (props) => {
  // Props Destructuring
  const {
    children,
    onClick,
    onLongPress,
    defaultOptions,
    className,
    disabled,
    style
  } = props;
  const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);
 // HTML CSS CODE
  return (
    <button
      {...longPressEvent}
      type="button"
      className={cn('w-100 position-relative', className)}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;
